import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { teamQueryKeys } from '../teamQueryKeys';
import { fetchTeamApiToken } from 'ReportsModule/services';
import {
  FetchTeamApiTokenErrorResponse,
  FetchTeamApiTokenPayload,
  FetchTeamApiTokenSuccessResponse,
} from 'TeamModule/types';

export const useGenerateTeamApiTokenQuery = ({
  enabled,
  ...params
}: FetchTeamApiTokenPayload & {
  enabled?: boolean;
}) => {
  const { data: queryData, ...apiTokenQuery } = useAppQuery<
    FetchTeamApiTokenSuccessResponse,
    FetchTeamApiTokenErrorResponse
  >({
    queryKey: teamQueryKeys.detail({
      teamId: params.team_id,
      identifier: `useGenerateTeamApiTokenQuery`,
    }),
    queryFn: ({ token, buildConfig }) => {
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      return fetchTeamApiToken({
        params,
        token,
        config: buildConfig(),
      }) as Promise<FetchTeamApiTokenSuccessResponse>;
    },
    enabled,
    gcTime: 0, // Clear cache when unmounting
    retry: false, // Do not refetch on failure
  });

  const apiToken = queryData?.data?.key;
  const apiTokenError = apiTokenQuery?.error?.data?.error;

  return {
    apiToken,
    apiTokenError,
    apiTokenQuery,
    refetchApiToken: apiTokenQuery.refetch,
    isFetchingApiToken: apiTokenQuery.isFetching,
  };
};
